import angular from 'angular';
import { IArquivoTrabalhadorUploadForm } from './arquivos.trabalhador.upload.modal.model';

export class MeurhArquivosTrabalhadorUploadModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) {}

    open() {
        const entity: IArquivoTrabalhadorUploadForm = {
            nome: '',
            competenciaano: null,
            competenciames: null,
            file: null,
        };

        return this.$uibModal.open({
            template: require('html-loader!./arquivos.trabalhador.upload.modal.html'),
            controller: 'MeurhArquivosTrabalhadorUploadModalController',
            controllerAs: '$ctrl',
            windowClass: 'nsj-modal-lg-no-height',
            backdrop: 'static',
            resolve: {
                entity: () => angular.copy(entity),
            },
        });
    }
}
